/**
 * wonUnit : 원화 단가 단위
 */
export const usePriceSetter = (wonUnit: string | null, currency: number) => {

    const applyCurrencyValue = (v: string | number) => {
        const value = Number(v) * Number(currency)

        if (wonUnit) {
            switch (Number(wonUnit)) {
                case 600:
                    return Number(value.toFixed(2)); // 소수점 두자리
                case 601:
                    return Math.floor(value); // 소수점 절삭
                case 602:
                    return Math.floor(value / 10) * 10; // 원단위 절삭
                case 603:
                    return Math.floor(value / 100) * 100; // 십단위 절삭
                case 604:
                    return Math.floor(value / 1000) * 1000; // 백단위 절삭
                case 605:
                    return Math.floor(value / 10000) * 10000; // 천단위 절삭
                default:
                    return value;
            }
        } else {
            return value
        }
    }

    const applyWonUnitValue = (v: string | number) => {
        const value = Number(v)

        if (wonUnit) {
            switch (Number(wonUnit)) {
                case 600:
                    return Number(value.toFixed(2)); // 소수점 두자리
                case 601:
                    return Math.floor(value); // 소수점 절삭
                case 602:
                    return Math.floor(value / 10) * 10; // 원단위 절삭
                case 603:
                    return Math.floor(value / 100) * 100; // 십단위 절삭
                case 604:
                    return Math.floor(value / 1000) * 1000; // 백단위 절삭
                case 605:
                    return Math.floor(value / 10000) * 10000; // 천단위 절삭
                default:
                    return value;
            }
        } else {
            return value
        }
    }

    const isNanSumValue = (l: (string | number)[]) => {
        return isNaN(Number(l.reduce((acc, cur) => Number(acc) + Number(cur), 0)))
    }

    const sumValue = (l: (string | number)[]) => {
        return l.reduce((acc, cur) => Number(acc) + Number(cur), 0)
    }


    return {applyCurrencyValue, applyWonUnitValue, isNanSumValue, sumValue}
}